import Branding from '../../libs/branding/setup';
import BrandingThemes from '../../libs/branding/themes';

const branding = new Branding();

export default { themes: BrandingThemes[branding.branding] || BrandingThemes.default };
